import { Chip, type ChipProps, Tooltip, type TooltipProps } from '@mui/material'

/**
 * Because of the Tooltip wrapper, 'aria-label': string can be passed
 * into `chipProps` to aid in testing.
 */
export function ChipWithTooltip({
  tooltipProps,
  ...chipProps
}: ChipProps & {
  tooltipProps: Omit<TooltipProps, 'children'>
}) {
  return (
    <Tooltip arrow role="status" {...tooltipProps}>
      <Chip size="small" {...chipProps} />
    </Tooltip>
  )
}
